import { BRAND_SHADES, getBrandHex } from 'lib/constants/brandPalette';

import OptionCard from './OptionCard';

const ShadeSelector = ({ colorKey, value, onChange, dataQaPrefix = 'brand-shade' }) => (
  <div className="flex w-full items-stretch gap-3">
    {BRAND_SHADES.map((shade) => (
      <OptionCard
        key={shade.value}
        isSelected={value === shade.value}
        onSelect={() => onChange(shade.value)}
        className="h-[92px] flex-1 flex-col justify-center gap-1 px-4 py-3"
        data-qa={`${dataQaPrefix}-${shade.value}`}>
        <span
          className="block h-10 w-10 rounded-full"
          style={{ backgroundColor: getBrandHex(colorKey, shade.value) }}
        />
        <span className="text-base leading-6 text-neutral-900">{shade.label}</span>
      </OptionCard>
    ))}
  </div>
);

export default ShadeSelector;
